<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="page-header">
          <div class="content-page-header">
            <h5>Invoices Overdue</h5>
            <div class="list-btn">
              <ul class="filter-list">
                <li>
                  <a class="btn-filters w-auto popup-toggle"
                    ><span><i class="feather feather-filter"></i></span>
                  </a>
                </li>
                <li>
                  <a
                    @click="openModal(null, 'export')"
                    class="btn-filters w-auto"
                    ><span><i class="feather feather-download-cloud"></i></span>
                  </a>
                </li>
                <li>
                  <router-link class="btn btn-primary" to="/add-invoice"
                    ><i class="fa fa-plus-circle me-2" aria-hidden="true"></i
                    >New Invoice</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <!-- Add Asset -->
        <div class="toggle-sidebar">
          <div class="sidebar-layout-filter">
            <div class="sidebar-header">
              <h5>Filter</h5>
              <a href="javascript:;" class="sidebar-closes"
                ><i class="fa-regular fa-circle-xmark"></i
              ></a>
            </div>
            <div class="sidebar-body">
              <b-form action="#" autocomplete="off">
                <!-- Estimates -->
                <div class="accordion" id="accordionMain1">
                  <a
                    href="javascript:void(0);"
                    class="w-100"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <div class="card-header-new" id="headingOne">
                      <h6 class="filter-title">
                        Invoices
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseOne"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample1"
                  >
                    <div class="card-body-chat">
                      <div class="row">
                        <div class="col-md-12">
                          <div id="checkBoxes1">
                            <div class="form-custom">
                              <input
                                type="text"
                                class="form-control"
                                v-model="searchForm.search"
                                id="member_search1"
                                placeholder="Search here"
                              />
                              <span
                                ><img
                                  src="@/assets/img/icons/search.svg"
                                  alt="img"
                              /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Customer -->

                <!-- Select Date -->
                <div class="accordion" id="accordionMain2">
                  <a
                    href="javascript:void(0);"
                    class="w-100 collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="true"
                    aria-controls="collapseTwo"
                  >
                    <div class="card-header-new" id="headingTwo">
                      <h6 class="filter-title">
                        Select Date
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseTwo"
                    class="collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample2"
                  >
                    <div class="card-body-chat">
                      <div class="form-group">
                        <label class="form-control-label">From</label>
                        <div class="cal-icon">
                          <datepicker
                            v-model="searchForm.from"
                            class="picker"
                            :editable="true"
                            :clearable="false"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">To</label>
                        <div class="cal-icon">
                          <datepicker
                            v-model="searchForm.to"
                            class="picker"
                            :editable="true"
                            :clearable="false"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Select Date -->

                <button
                  @click="resetSearchForm"
                  class="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary"
                >
                  <span><i class="feather feather-refresh-ccw me-2"></i></span
                  >Reset
                </button>
              </b-form>
            </div>
          </div>
        </div>
        <!--/Add Asset -->
        <invoicecard />
        <invoicetab v-model="searchForm.search"/>
        <!-- Table -->
        <div class="row">
          <div class="col-sm-12">
            <div class="card-table">
              <div class="card-body">
                <div class="table-responsive">
                  <a-table
                    :columns="columns"
                    :data-source="invoices.data"
                    :loading="isFetching"
                    :pagination="false"
                  >
                    <template #bodyCell="{ column, record, index }">
                      <template v-if="column.key === 'index'">
                        <span>{{ index + 1 }}</span>
                      </template>
                      <template v-else-if="column.key === 'invoice_id'">
                        <router-link
                          style="color: #878a99"
                          :to="`/invoice-details/` + record.id"
                        >
                          {{ record.invoice_id }}
                        </router-link>
                      </template>
                      <template v-else-if="column.key === 'customer'">
                        <router-link
                          style="color: #878a99"
                          :to="`/customer-details/` + record.customer.id"
                        >
                          {{ record.customer.name }}
                        </router-link>
                      </template>
                      <template v-else-if="column.key === 'total_amount'">
                        <span
                          >{{ record.currency.slice(0, 4) }}
                          {{ addCurrencyComma(record.total_amount) }}</span
                        >
                      </template>
                      <template v-else-if="column.key === 'date'">
                        {{ formatted(record.date) }}
                      </template>
                      <template v-else-if="column.key === 'due_date'">
                        {{ formatted(record.due_date) }}
                      </template>

                      <template v-else-if="column.key === 'status'">
                        <span
                          class="badge bg-danger-light text-danger-light text-capitalize"
                          v-if="record.status === 'overdue'"
                          >{{ record.status }}</span
                        >
                      </template>
                      <template v-if="column.key === 'action'">
                        <div
                          class="d-flex align-items-center justify-content-start"
                        >
                          <div class="dropdown dropdown-action">
                            <a
                              class="btn-action-icon"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              >Action</a
                            >
                            <div class="dropdown-menu dropdown-menu-end">
                              <ul>
                                <li>
                                  <router-link
                                    class="dropdown-item"
                                    :to="`/invoice-details/` + record.id"
                                    ><i class="far fa-eye me-2"></i
                                    >View</router-link
                                  >
                                </li>
                                <li>
                                  <router-link
                                    class="dropdown-item"
                                    :to="`/edit-invoice/` + record.id"
                                    ><i class="far fa-edit me-2"></i
                                    >Edit</router-link
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    @click="openModal(record, 'send')"
                                    ><i class="fa fa-bolt text-success me-2"></i
                                    >Send</a
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    @click="openModal(record, 'delete')"
                                    ><i
                                      class="far fa-trash-alt text-danger me-2"
                                    ></i
                                    >Delete</a
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    @click="openModal(record, 'duplicate')"
                                    ><i class="far fa-clone me-2"></i
                                    >Duplicate</a
                                  >
                                </li>
                                <!-- <li
                                  v-if="
                                    record.status == 'sent' ||
                                    record.status == 'viewed' ||
                                    record.status == 'draft'
                                  "
                                >
                                  <a
                                    class="dropdown-item"
                                    @click="openModal(record, 'accept')"
                                    ><i
                                      class="fa fa-check-circle text-success me-2"
                                    ></i
                                    >Mark as Accepted</a
                                  >
                                </li> -->
                                <li
                                  v-if="
                                    record.status == 'sent' ||
                                    record.status == 'viewed' ||
                                    record.status == 'draft'
                                  "
                                >
                                  <a
                                    class="dropdown-item"
                                    @click="openModal(record, 'refund')"
                                    ><i class="fa fa-undo me-2"></i>Mark as
                                    refunded</a
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    @click="openPaymentModal(record)"
                                    ><i
                                      class="feather feather-credit-card me-2"
                                    ></i
                                    >Record Payment</a
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    @click="openModal(record, 'send-reminder')"
                                    ><i class="fa fa-bolt text-success me-2"></i
                                    >Send Reminder</a
                                  >
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </a-table>
                </div>
                <div class="d-flex justify-content-end">
                  <a-pagination
                    class="mt-4"
                    :current="currentPage"
                    :total="total"
                    :page-size="perPage"
                    :show-size-changer="false"
                    :show-quick-jumper="false"
                    @change="handlePageChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Table -->
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- Delete Expense Modal -->
  <div class="modal custom-fade fade" id="delete_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>
              <span v-if="selectedAction === 'delete'">Delete Invoice</span>
              <span v-if="selectedAction === 'send'">Send Invoice</span>
              <span v-if="selectedAction === 'send-reminder'"
                >Send Reminder</span
              >
              <span v-if="selectedAction === 'duplicate'"
                >Duplicate Invoice</span
              >
              <span v-if="selectedAction === 'refund'">Refund Invoice</span>
              <span v-if="selectedAction === 'accept'">Accept Invoice</span>
              <span v-if="selectedAction === 'export'">Export Invoice</span>
            </h3>
            <p v-if="selectedItem">
              Are you sure want to
              <span v-if="selectedAction === 'delete'">delete</span>
              <span v-if="selectedAction === 'send'">send</span>
              <span v-if="selectedAction === 'send-reminder'"
                >send Reminder for</span
              >
              <span v-if="selectedAction === 'duplicate'">duplicate</span>
              <span v-if="selectedAction === 'refund'">refund</span>
              <span v-if="selectedAction === 'accept'">accept</span>
              <span class="fw-semibold ms-1">{{
                selectedItem.customer.name
              }}</span>
              Invoice?
            </p>
            <p v-if="selectedItem === null">
              Are you sure want to
              <span v-if="selectedAction === 'export'">export</span> Invoices?
            </p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row d-flex flex-column align-items-center">
              <div class="col-6 mb-2">
                <button
                  v-if="selectedAction === 'delete'"
                  @click="deleteInvoice"
                  class="w-100 btn btn-danger"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Delete</span>
                  <span v-if="isLoading">Deleting...</span>
                </button>
                <button
                  v-if="selectedAction === 'send'"
                  @click="sendInvoice"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Send</span>
                  <span v-if="isLoading">Sending...</span>
                </button>
                <button
                  v-if="selectedAction === 'send-reminder'"
                  @click="sendReminder"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Send</span>
                  <span v-if="isLoading">Sending...</span>
                </button>
                <button
                  v-if="selectedAction === 'refund'"
                  @click="markAs('refunded')"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Refund</span>
                  <span v-if="isLoading">Refunding...</span>
                </button>
                <button
                  v-if="selectedAction === 'accept'"
                  @click="markAs('accepted')"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Accept</span>
                  <span v-if="isLoading">Accepting...</span>
                </button>
                <button
                  v-if="selectedAction === 'duplicate'"
                  @click="duplicateInvoices"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Duplicate</span>
                  <span v-if="isLoading">Duplicating...</span>
                </button>
                <button
                  v-if="selectedAction === 'export'"
                  @click="exportInvoice"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Export</span>
                  <span v-if="isLoading">Exporting...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Expense Modal -->
  <recordpayment
    :form="payment_form"
    :selectedItem="selectedItem"
    @closePaymentModal="closePaymentModal"
  />
  <!-- /Main Wrapper -->
</template>
<script setup>
import { computed, ref, onMounted, watch } from "vue";
import { formatted, formatDateToDashDigits } from "@/assets/composables/date";
import { addCurrencyComma } from "@/assets/composables/currency";
import { useStore } from "vuex";
import { Modal } from "bootstrap";

const store = useStore();
const isFetching = ref(false);
const currentPage = ref(1);
const perPage = ref(50);
const selectedItem = ref(null);
const selectedAction = ref(null);
const modalInstance = ref(null);
const isLoading = ref(false);
const paymentModal = ref(null);

const payment_form = ref({
  invoice_id: "",
  date: new Date(),
  method: "",
  amount: "",
  notify_client: false,
  notify_channels:[],
});

const resetPaymentForm = () => {
  payment_form.value = {
    invoice_id: "",
    date: new Date(),
    method: "",
    amount: "",
    notify_client: false,
    notify_channels:[],
  };
};

const resetSearchForm = () => {
  searchForm.value = {
    search: "",
    from: "",
    to: "",
  };
};

const searchForm = ref({
  search: "",
  from: "",
  to: "",
});

watch(
  () => searchForm.value,
  (newValue) => {
    isFetching.value = true;
    let data = {
      current_page: currentPage.value,
      per_page: perPage.value,
      query: newValue.search,
      filter: {
        status: ["overdue"],
        date: {
          mode: "range",
          range: {
            from:
              newValue.from != "" ? formatDateToDashDigits(newValue.from) : "",
            to: newValue.to != "" ? formatDateToDashDigits(newValue.to) : "",
          },
        },
      },
    };
    store.dispatch("invoices/getInvoices", data).then(() => {
      isFetching.value = false;
    });
  },
  { deep: true }
);

const handlePageChange = (page) => {
  currentPage.value = page;
};

watch(currentPage, (newValue) => {
  currentPage.value = newValue;
  getInvoices();
});

const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Invoice ID",
    key: "invoice_id",
    sorter: true,
  },
  {
    title: "Customer",
    key: "customer",
    sorter: true,
  },
  {
    title: "Amount",
    key: "total_amount",
    sorter: true,
  },
  {
    title: "Date Created",
    key: "date",
    sorter: true,
  },
  {
    title: "Expiry Date",
    key: "due_date",
    sorter: true,
  },
  {
    title: "Status",
    key: "status",
    sorter: true,
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const openModal = (estimate, name) => {
  isLoading.value = false;
  selectedAction.value = name;
  selectedItem.value = estimate;
  modalInstance.value.show();
};
const closeModal = () => {
  modalInstance.value.hide();
};

const openPaymentModal = (invoice) => {
  isLoading.value = false;
  selectedItem.value = invoice;
  payment_form.value.invoice_id = invoice.id;
  payment_form.value.amount = invoice.amount_due;
  paymentModal.value.show();
};
const closePaymentModal = () => {
  paymentModal.value.hide();
  resetPaymentForm();
};

const invoices = computed(() => {
  return store.getters["invoices/invoices"];
});

const total = computed(() => {
  return store.getters["invoices/total"];
});

const getInvoices = () => {
  isFetching.value = true;
  let data = {
    current_page: currentPage.value,
    per_page: perPage.value,
    filter: {
      status: ["overdue"],
    },
  };
  store
    .dispatch("invoices/getInvoices", data)
    .then(() => {
      isFetching.value = false;
    })
    .catch(() => {
      isFetching.value = false;
    });
};

const duplicateInvoices = () => {
  isLoading.value = true;
  store
    .dispatch("invoices/duplicateInvoices", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeModal();
      getInvoices();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};

const sendInvoice = () => {
  isLoading.value = true;
  store
    .dispatch("invoices/sendInvoice", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeModal();
      getInvoices();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};
const sendReminder = () => {
  isLoading.value = true;
  store
    .dispatch("invoices/sendReminder", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeModal();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};

const deleteInvoice = () => {
  isLoading.value = true;
  store
    .dispatch("invoices/deleteInvoice", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeModal();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};

const markAs = (action) => {
  isLoading.value = true;
  let data = {
    id: selectedItem.value.id,
    payload: {
      status: action,
    },
  };

  store
    .dispatch("invoices/markAs", data)
    .then(() => {
      isLoading.value = false;
      closeModal();
      getInvoices();
    })
    .catch(() => {
      isLoading.value = false;
      closeModal();
    });
};

const exportInvoice = async () => {
  isLoading.value = true;
  await store
    .dispatch("invoices/exportInvoice")
    .then(() => {
      saveExcel(store.state.invoices.url);
    })
    .then(() => {
      closeModal();
      isLoading.value = false;
    })
    .catch(() => {
      closeModal();
      isLoading.value = false;
    });
};

const saveExcel = (fileUrl) => {
  const link = document.createElement("a");
  link.href = fileUrl;
  link.setAttribute("download", "fileName");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

onMounted(() => {
  getInvoices();
  if (document.querySelectorAll(".popup-toggle").length > 0) {
    document.querySelectorAll(".popup-toggle").forEach(function (el) {
      el.addEventListener("click", function () {
        document.querySelector(".toggle-sidebar").classList.add("open-filter");
      });
    });

    document.querySelectorAll(".sidebar-closes").forEach(function (el) {
      el.addEventListener("click", function () {
        document
          .querySelector(".toggle-sidebar")
          .classList.remove("open-filter");
      });
    });
  }

  // Initiate modal
  modalInstance.value = new Modal(document.getElementById("delete_modal"), {
    backdrop: "static",
    keyboard: false,
  });
  paymentModal.value = new Modal(document.getElementById("payment_modal"), {
    backdrop: "static",
    keyboard: false,
  });
});
</script>
